module.exports = __webpack_public_path__ + "img/innovations_medium@2x.fd1e4fd5.webp";